var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:_vm._ref,class:_vm._class,attrs:{"type":"file","id":_vm.id,"accept":_vm.accept},on:{"change":function($event){return _vm.onChange($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }